import { gql } from "apollo-angular";
import { LINK_FIELDS } from "./link";

const FCF =  gql`
fragment FCF on FooterCta {
    sys {
      id
    }
    isPzd
    backgroundColor {
      color
    }
    headerTag
    hTagId
    header
    alignment
    content
    linksCollection(limit:6) {
      items {
        ... LINK_FIELDS
      }
    }
    disclaimer {
      ... on DisclaimerItem {
        disclaimer
      }
    }
  }
${LINK_FIELDS}`

export {FCF}